export const ROUTE_PATH = '/parking-tower-stop-list';

export const FEATURE_NAME = 'parkingTowerStopListPage';
